// K+
// import Constants from "../../api/Constants";

export default{
    name: "TwoColumns",
    data(){
        return{

        }
    },
    props: {
        title: {
            type: String
        },
        description: {
            type: String
        },
        imagePath: {
            type: String
        },
        flip: {
            type: Boolean,
            default: false
        }
    }
}
